<template>
  <div class="relative flex items-center justify-center gap-2 text-sm">
    <UIcon
      class="size-4.5 -mt-1.5 flex-shrink-0 -scale-x-100 transform"
      :name="getIcon('arrowPointingTop')"
    />

    <slot />

    <UIcon
      class="size-4.5 -mt-1.5 flex-shrink-0"
      :name="getIcon('arrowPointingTop')"
    />
  </div>
</template>
